export function classifyCalendarEvent(eventTitle, calendarColor) {
  const cleanedTitle = eventTitle
    .toLowerCase()
    .replace(/[-:]/g, '') // remove punctuation like dashes and colons
    .trim()
  if (cleanedTitle.includes('district closed')) {
    return '#E8350F' // dark red
  }

  if (
    cleanedTitle.includes('no school') || cleanedTitle.includes ('no students') &&
    !cleanedTitle.includes('elementary') &&
    !cleanedTitle.includes('middle')
  ) {
    return '#FFD700' // dark yellow
  }

  if (cleanedTitle.includes('no middle')) {
    return '#CB78F1' // light purple
  }

  if (
    cleanedTitle.includes('no elementary') ||
    cleanedTitle.includes('elementary only')
  ) {
    return '#2fc856' // medium green
  }

  if (
    cleanedTitle.includes('professional learning communities') ||
    cleanedTitle.includes('plc')
  ) {
    return '#70ddfb' // light blue
  }
  if (
    cleanedTitle.includes('semester') ||
    cleanedTitle.includes('quarter')
  ) {
    return '#6e6f6e' // dark grey
  }
  if (
    cleanedTitle.includes('blue day')
  ) {
    return '#0c5cbe' // dark blue
  }
  if (
    cleanedTitle.includes('silver day')
  ) {
    return '#E1E2EB' // light grey
  }
  if (
    cleanedTitle.includes('green day')
  ) {
    return '#53ce32' // green
  }
  if (
    cleanedTitle.includes('purple day')
  ) {
    return '#6503cc' // purple
  }
  if (
    cleanedTitle.includes('gold day')
  ) {
    return '#C8B223' // gold
  }
  if (
    cleanedTitle.includes('red day')
  ) {
    return '#FBB5B5' // light red
  }

  return '#bababa'
}
